module.exports = __webpack_public_path__ + "img/gallery_img_03.296f9f32.jpg";